import "../css/StaffRoll.css";
import slots from "../data/slots.json";

const StaffRoll = ({ onClose }) => {
  return (
    <div className="staff-overlay" onClick={onClose}>
      <div className="staff-content" onClick={(e) => e.stopPropagation()}>
        <div className="scrolling-text">
          <h1>🎗️制作スタッフ🎗️</h1>
          <h3>🔹🔹ワールドクリエイター🔹🔹</h3>
          <div class="roll-account">
            <p class="roll-account-name">チンチロ刑務所🎲ChinChilloPrison</p>
            <p class="roll-account-x">@chinchillo_p</p>
          </div>
          <p>🔹🔹スロットデザイナー🔹🔹</p>
          {slots.map((slot) => (
            <>
              <p class="roll-title">🎰{slot.name}🎰</p>
              <div class="roll-account">
                <p class="roll-account-name">{slot.manufacturer}</p>
                <p class="roll-account-x">@{slot.account}</p>
              </div>
            </>
          ))}
          <p>🔹🔹ウェブ制作・エンジニア🔹🔹</p>
          <div class="roll-account">
            <p class="roll-account-name">tommy🚴🏼ITエンジニア</p>
            <p class="roll-account-x">@dtomida</p>
          </div>
          <div class="staff-image">
            <img src="images/staff/tommy.png" />
          </div>
          <p>🔹🔹スポンサー🔹🔹</p>
          <p> - スタエフメンバーシップ - </p>
          <p>ガータロ@長崎五島のNFT観光大使</p>
          <p>SPMA</p>
          <p>cash81 a.k.a Crypto U.J.T</p>
          <p>ヒオキン (NFT/コミュニティ)</p>
          <p>march</p>
          <p>gken</p>
          <p>yurimi</p>
          <p>🔹🔹スペシャルサンクス🔹🔹</p>
          <p>スロットユーザーの皆様</p>
          <p class="staff-note"></p>
          <div class="staff-image">
            パーラーペロ猫
            <img src="images/staff/chin.jpg" />
            雇われ店長 チンチロ刑務所
          </div>
        </div>
        <button className="close-btn-staff" onClick={onClose}>
          閉じる
        </button>
      </div>
    </div>
  );
};

export default StaffRoll;
